import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { NAV_LINKS, LOGO, CONTACT, IMAGES } from "@/data/content";

const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden bg-forest text-ivory grain"
      data-testid="site-footer"
    >
      {/* faint texture backdrop */}
      <div
        className="absolute inset-0 opacity-[0.10] bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.texture})` }}
        aria-hidden="true"
      />
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-10">
        {/* Top CTA line */}
        <Reveal className="border-b border-ivory/15 py-20 md:py-28">
          <p className="kicker text-gold mb-6">Begin the conversation</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
            <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.05] max-w-3xl">
              Your quietest, most spacious self is closer than you think.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta-consultation"
              className="shrink-0 inline-flex items-center gap-3 border border-ivory/40 px-8 py-4 uppercase tracking-[0.16em] text-xs transition-colors duration-500 hover:bg-ivory hover:text-forest"
            >
              Book a Consultation
            </Link>
          </div>
        </Reveal>

        {/* Middle grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 py-16 md:py-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="bg-ivory rounded-full p-2">
                <img src={LOGO} alt="Svara Chakra" className="h-11 w-11 object-contain" />
              </span>
              <span className="font-serif text-2xl">Svara Chakra</span>
            </div>
            <p className="text-ivory/70 font-light leading-relaxed max-w-sm text-sm">
              A refined wellness ecosystem where ancient wisdom meets contemporary
              wellbeing — music therapy, energy healing, mindfulness and conscious living.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="kicker text-ivory/50 mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.slice(0, 6).map((l) => (
                <li key={l.label}>
                  {l.type === "route" ? (
                    <Link
                      to={l.to}
                      className="text-ivory/80 text-sm hover:text-gold transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <span className="text-ivory/80 text-sm">{l.label}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="kicker text-ivory/50 mb-6">Reach us</p>
            <ul className="space-y-3 text-sm text-ivory/80">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors duration-300">
                  {CONTACT.email}
                </a>
              </li>
              <li>{CONTACT.phone}</li>
              <li>{CONTACT.location}</li>
              <li className="text-ivory/50">{CONTACT.hours}</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-ivory/15 py-8">
          <p className="text-center kicker text-gold text-[0.62rem] mb-6">
            Designed to be experienced, not just explored.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-ivory/50">
            <p>© {new Date().getFullYear()} Svara Chakra. All rights reserved.</p>
            <p className="tracking-[0.14em] uppercase">Sound · Stillness · Renewal</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
